module.exports = __webpack_public_path__ + "static/media/default.72244544.jpg";